import Vue from "vue";
import VueRouter from "vue-router";
import Clipboard from 'v-clipboard'
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.use(vueCountryRegionSelect)
Vue.use(VueRouter);
Vue.use(Clipboard);

const routes = [
    {
        path: "/showcase/:showcase_fingerprint/checkout",
        name: "showcase_checkout",
        component: () => import("../views/ShowcaseCheckout.vue")
    },
    {
        path: "/:showcase_fingerprint",
        name: "showcase_consumer",
        component: () => import("../views/ShowcaseConsumer.vue"),
    },
    {
        path: "/:lang/:showcase_fingerprint",
        name: "showcase_consumer_with_lang",
        component: () => import("../views/ShowcaseConsumer.vue")
    }
];

const routerShowcase = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    linkActiveClass: "active", // active class for non-exact links.
    linkExactActiveClass: "active", // active class for *exact* links.
    routes
});

export default routerShowcase;
